import DetalhesParque from './DetalhesParque';
export default DetalhesParque;